import React, { useEffect, useState } from "react";
import axios from "axios";
import { css } from "@emotion/react";
import { axiosPath } from "@src/api/axiosPath";
import { Button } from "@src/components";
import { useNavigate } from "react-router-dom";
import { WebAppBridge } from "@src/lib/WebAppBridge";
import { updateUserSession } from "@src/api/axios";

const nestURL = process.env.REACT_APP_NEST_API_URL;

interface userInfoProps {
    id: string;
    productName: string;
    uname: string;
}

function Login() {
    const navigate = useNavigate();
    const [welcomeMsg, setWelcomeMsg] = useState("");
    const [loginInput, setLoginInput] = useState("");
    const [userInfo, setUserInfo] = useState<userInfoProps | null>(null);
    const [isLogined, setIsLogined] = useState(false);

    const fetchUserInfo = async () => {
        try {
            const response = await axios.get(`${nestURL}/user`, {
                headers: { Authorization: `Bearer ${localStorage.getItem("accessToken")}` },
            });
            setIsLogined(true);
            setWelcomeMsg("로그인 되었습니다.");
            setUserInfo(response.data);
        } catch (error) {
            if (axios.isAxiosError(error) && error.response) {
                if (error.response.status) {
                    localStorage.removeItem("accessToken");
                    localStorage.removeItem("refreshToken");
                }
            }
        }
    };

    useEffect(() => {
        fetchUserInfo();
    }, []);

    const handleMatchSuccessWithEmail = async () => {
        let email = "";
        let password = "";

        if (loginInput.startsWith("@")) {
            const withoutAt = loginInput.slice(1);
            [email, password] = withoutAt.split("/");
        } else if (loginInput.startsWith("t")) {
            const [rawEmail, pw] = loginInput.split("/");
            email = `${rawEmail}@msga.msg`;
            password = pw;
        } else {
            return;
        }

        await axios
            .post(`${axiosPath.login}`, {
                id: email,
                password: {
                    password: password,
                },
            })
            .then((res: any) => {
                let payload = res.data;
                const { accessToken, refreshToken } = payload;
                localStorage.setItem("isSubscription", "true");
                localStorage.setItem("accessToken", accessToken);
                localStorage.setItem("refreshToken", refreshToken);
                updateUserSession(accessToken, refreshToken);
                fetchUserInfo();
                setWelcomeMsg(`로그인 되었습니다.`);
            })
            .catch((e) => alert(e));
    };

    return (
        <div css={loginWrap}>
            <div className="step1">
                {isLogined ? (
                    <div css={LoginInputBox}>
                        <span>
                            {welcomeMsg} <br />
                            id : {userInfo?.id} <br />
                            구독권 : {userInfo?.productName} <br />
                            이름 : {userInfo?.uname} <br />
                        </span>
                        <button
                            className="loginBtn"
                            onClick={() => {
                                localStorage.removeItem("isSubscription");
                                localStorage.removeItem("accessToken");
                                localStorage.removeItem("refreshToken");
                                window.location.reload();
                            }}
                        >
                            로그아웃
                        </button>
                    </div>
                ) : (
                    <div css={LoginInputBox}>
                        <input
                            css={LoginInput}
                            type="text"
                            value={loginInput}
                            onChange={(e) => setLoginInput(e.currentTarget.value)}
                            onKeyDown={(evt: React.KeyboardEvent<HTMLInputElement>) => {
                                if (evt.key === "Enter") {
                                    handleMatchSuccessWithEmail();
                                }
                            }}
                        />
                        <button className="loginBtn" onClick={handleMatchSuccessWithEmail}>
                            로그인하기
                        </button>
                    </div>
                )}
                {isLogined && (
                    <>
                        <h3>2. 상세 페이지로 이동하세요.</h3>
                        <ul>
                            <li>
                                <span>지도 페이지</span>
                                <Button
                                    color="purple"
                                    handleClick={() => navigate("/map?search=0")}
                                    label="지도"
                                    size="small"
                                    deleteBtn={true}
                                />
                            </li>
                            {/* <li>
                                <span>지도 검색 페이지</span>
                                <Button
                                    color="purple"
                                    handleClick={() => navigate("/map?search=1")}
                                    label="지도 검색"
                                    size="small"
                                    deleteBtn={true}
                                />
                            </li> */}
                            <li>
                                <span>지도 필터(네이티브연동) 페이지</span>
                                <Button
                                    color="purple"
                                    handleClick={() => navigate("/mapFilter")}
                                    label="앱지도 필터"
                                    size="small"
                                    deleteBtn={true}
                                />
                            </li>
                            <li>
                                <span>매물검색 - 필터/검색/최근검색어 전용 페이지</span>
                                <Button
                                    color="purple"
                                    handleClick={() => navigate("/searchItems")}
                                    label="매물검색"
                                    size="small"
                                    deleteBtn={true}
                                />
                            </li>
                            <li>
                                <span>AI 맞춤필터 페이지</span>
                                <Button
                                    color="purple"
                                    handleClick={() => navigate("/aiFilterV2")}
                                    label="Ai 맞춤필터"
                                    size="small"
                                    deleteBtn={true}
                                />
                            </li>
                            <li>
                                <span>소액 맞춤필터 페이지</span>
                                <Button
                                    color="purple"
                                    handleClick={() => navigate("/smallFilter")}
                                    label="소액 맞춤필터"
                                    size="small"
                                    deleteBtn={true}
                                />
                            </li>
                            <li>
                                <span>등기 변동 알림 페이지</span>
                                <Button
                                    color="purple"
                                    handleClick={() => navigate("/deungi/alarm")}
                                    label="등기변동알림"
                                    size="small"
                                    deleteBtn={true}
                                />
                            </li>
                            <li>
                                <span>등기부등본 페이지</span>
                                <Button
                                    color="purple"
                                    handleClick={() => navigate("/deungi")}
                                    label="등기부등본"
                                    size="small"
                                    deleteBtn={true}
                                />
                            </li>
                            <li>
                                <span>법인 등기부등본 페이지</span>
                                <Button
                                    color="purple"
                                    handleClick={() => navigate("/corpDeungi")}
                                    label="법인 등기부등본"
                                    size="small"
                                    deleteBtn={true}
                                />
                            </li>
                            <li>
                                <span>등기부등본 열람권 충전 페이지</span>
                                <Button
                                    color="purple"
                                    handleClick={() => navigate("/deungi/payment")}
                                    label="등기부등본 열람권 충전 페이지"
                                    size="small"
                                    deleteBtn={true}
                                />
                            </li>
                            <li>
                                <span>미스고 캠퍼스</span>
                                <Button
                                    color="purple"
                                    handleClick={() => navigate("/campus")}
                                    label="미스고 캠퍼스"
                                    size="small"
                                    deleteBtn={true}
                                />
                            </li>
                            <li>
                                <span>미스고 캠퍼스 취소/환불</span>
                                <Button
                                    color="purple"
                                    handleClick={() => navigate("/campus/refund")}
                                    label="미스고 캠퍼스"
                                    size="small"
                                    deleteBtn={true}
                                />
                            </li>
                            <li>
                                <span>거리뷰</span>
                                <Button
                                    color="purple"
                                    handleClick={() => navigate("/panoramaView")}
                                    label="거리뷰 토큰"
                                    size="small"
                                    deleteBtn={true}
                                />
                            </li>
                            <li>
                                <span>환불하기</span>
                                <Button
                                    color="purple"
                                    handleClick={() => navigate("/unSubscribe")}
                                    label="환불하기"
                                    size="small"
                                    deleteBtn={true}
                                />
                            </li>
                            <li>
                                <span>전문가 문의 관리</span>
                                <Button
                                    color="purple"
                                    handleClick={() => navigate("/expert/inquiry")}
                                    label="전문가 문의 관리"
                                    size="small"
                                    deleteBtn={true}
                                />
                            </li>
                            <li>
                                <span>경매대행 지역광고 안내 팝업</span>
                                <Button
                                    color="purple"
                                    handleClick={() => navigate("/expert/localAd/introduction/popup")}
                                    label="경매대행 지역광고 안내 팝업"
                                    size="small"
                                    deleteBtn={true}
                                />
                            </li>
                            <li>
                                <span>광고 매물 관리</span>
                                <Button
                                    color="purple"
                                    handleClick={() => navigate("/expertAdList")}
                                    label="광고 매물 관리"
                                    size="small"
                                    deleteBtn={true}
                                />
                            </li>
                            <li>
                                <span>고스톱 유료페이지</span>
                                <Button
                                    color="purple"
                                    handleClick={() => navigate("/goStop")}
                                    label="고스톱 유료페이지"
                                    size="small"
                                    deleteBtn={true}
                                />
                            </li>
                            <li>
                                <span>상가 고스톱 유료페이지</span>
                                <Button
                                    color="purple"
                                    handleClick={() => navigate("/storeGoStop")}
                                    label="상가 고스톱 유료페이지"
                                    size="small"
                                    deleteBtn={true}
                                />
                            </li>
                            <li>
                                <span>광고권 취소/환불하기</span>
                                <Button
                                    color="purple"
                                    handleClick={() => navigate("/advertisementCancelRefund")}
                                    label="광고권 취소/환불하기"
                                    size="small"
                                    deleteBtn={true}
                                />
                            </li>
                            <li>
                                <span>지역광고권 취소/환불하기</span>
                                <Button
                                    color="purple"
                                    handleClick={() => navigate("/regionAdsRefund")}
                                    label="지역광고권 취소/환불하기"
                                    size="small"
                                    deleteBtn={true}
                                />
                            </li>
                            <li>
                                <span>건축물대장 페이지</span>
                                <Button
                                    color="purple"
                                    handleClick={() => navigate("/buildingRegister")}
                                    label="건축물대장"
                                    size="small"
                                    deleteBtn={true}
                                />
                            </li>
                            <li>
                                <span>토지•임야대장 페이지</span>
                                <Button
                                    color="purple"
                                    handleClick={() => navigate("/landRegister")}
                                    label="토지•임야대장"
                                    size="small"
                                    deleteBtn={true}
                                />
                            </li>
                            <li>
                                <span>국유지 이용권 취소/환불하기</span>
                                <Button
                                    color="purple"
                                    handleClick={() => navigate("/stateLandRefund")}
                                    label="국유지 이용권 취소/환불하기"
                                    size="small"
                                    deleteBtn={true}
                                />
                            </li>
                            <li>
                                <span>도로확장 계획 취소/환불하기</span>
                                <Button
                                    color="purple"
                                    handleClick={() => navigate("/roadPlanRefund")}
                                    label="도로확장 계획 취소/환불하기"
                                    size="small"
                                    deleteBtn={true}
                                />
                            </li>
                            <li>
                                <span>주거/토지 프리미엄 필터 취소/환불하기</span>
                                <Button
                                    color="purple"
                                    handleClick={() => navigate("/goStopRefund")}
                                    label="주거/토지 프리미엄 필터 취소/환불하기"
                                    size="small"
                                    deleteBtn={true}
                                />
                            </li>
                            <li>
                                <span>상가 Go-Stop 취소/환불하기</span>
                                <Button
                                    color="purple"
                                    handleClick={() => navigate("/storeGoStopRefund")}
                                    label="상가 Go-Stop 취소/환불하기"
                                    size="small"
                                    deleteBtn={true}
                                />
                            </li>
                            <li>
                                <span>구독 상품 및 설명</span>
                                <div css={doubleBtnBoxStyle}>
                                    <Button
                                        color="purple"
                                        handleClick={() => navigate("/subscriptionInfo?type=6")}
                                        label="AOS 상품"
                                        size="small"
                                        deleteBtn={true}
                                    />
                                    <Button
                                        color="purple"
                                        handleClick={() => navigate("/ios-subscriptionInfo?type=7")}
                                        label="IOS 상품"
                                        size="small"
                                        deleteBtn={true}
                                    />
                                </div>
                            </li>
                            <li>
                                <span>국유지 이용권 및 설명</span>
                                <div css={doubleBtnBoxStyle}>
                                    <Button
                                        color="purple"
                                        handleClick={() => navigate("/stateLandInfo?type=8")}
                                        label="AOS 상품"
                                        size="small"
                                        deleteBtn={true}
                                    />
                                    <Button
                                        color="purple"
                                        handleClick={() => navigate("/stateLandInfo?type=7")}
                                        label="IOS 상품"
                                        size="small"
                                        deleteBtn={true}
                                    />
                                </div>
                            </li>
                            <li>
                                <span>국공유지 필터 (네이티브) 연동페이지</span>
                                <Button
                                    color="purple"
                                    handleClick={() => navigate("/stateLandUserFilter")}
                                    label="국공유지 필터"
                                    size="small"
                                    deleteBtn={true}
                                />
                            </li>
                            <li>
                                <span>Ios 데이터맵 이벤트 페이지</span>
                                <Button
                                    color="purple"
                                    handleClick={() => navigate("/introduction/IosDatamap")}
                                    label="Ios 데이터맵 이벤트 페이지"
                                    size="small"
                                    deleteBtn={true}
                                />
                            </li>
                            <li>
                                <span>소유자 열람권 충전 페이지</span>
                                <Button
                                    color="purple"
                                    handleClick={() => navigate("/ownerCheck/payment")}
                                    label="소유자 열람권 충전 페이지"
                                    size="small"
                                    deleteBtn={true}
                                />
                            </li>
                            <li>
                                <span>미스고AI & 챗봇</span>
                                <Button
                                    color="purple"
                                    handleClick={() => navigate("/missgoAI")}
                                    label="미스고AI & 챗봇"
                                    size="small"
                                    deleteBtn={true}
                                />
                            </li>
                             <li>
                                <span>오늘 변경된 매물</span>
                                <Button
                                    color="purple"
                                    handleClick={() => navigate("/statusItem")}
                                    label="오늘 변경된 매물 페이지"
                                    size="small"
                                    deleteBtn={true}
                                />
                            </li>
                        </ul>
                    </>
                )}
            </div>
        </div>
    );
}

const loginWrap = css`
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    overflow: scroll;

    line-height: 1.5;
    text-align: center;
    .loginBtn {
        padding: 10px;
        background-color: #ee5b7a;
        color: #fff;
        border-radius: 4px;
        font-size: 12px;
        cursor: pointer;
    }
    h3 {
        margin-top: 20px;
        margin-bottom: 10px;
    }
    .step1 span {
        font-size: 12px;
    }
    ul button {
        margin: 10px auto 0;
    }
    li {
        margin-bottom: 20px;
    }
`;

const doubleBtnBoxStyle = css`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    margin-top: 10px;
    button {
        margin: 0 !important;
    }
`;

const LoginInputBox = css`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 10px;
    margin-top: 10px;

    span {
        text-align: left;
    }
`;

const LoginInput = css`
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 14px;
    &:focus {
        outline: none;
        border-color: #007bff;
    }
`;

export default Login;
